<template>
  <v-dialog
    :value="value"
    @input="$emit('input', false)"
    width="500px"
  >
    <v-card class="pa-5 rounded-lg">
      <div class="font-weight-bold mb-2">Отправка группе</div>
      <div class="body-2 mb-3">Максимальный размер группы: {{ maxGroupSize }}</div>
      <v-text-field
        v-model="groupSize"
        label="Размер группы"
        outlined
        type="number"
        dense
        hide-details
        @input="validated = false"
        @blur="validateGroupSize()"
      />
      <v-row
        class="ma-0"
        justify="space-between"
      >
        <v-btn
          @click="accept()"
          class="mt-5"
          color="primary"
          :loading="loading"
          :disabled="!groupSize || !validated"
        >
          <div class="text-none">Отправить</div>
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'SendGroupModal',
    props: {
      value: Boolean,
      maxGroupSize: Number
    },
    emits: ['accept'],
    data: () => ({
      // TODO Добавить работу с maxGroupSizeLoading
      maxGroupSizeLoading: false,
      groupSize: 0,
      validated: false
    }),
    methods: {
      validateGroupSize() {
        this.validated = false
        if (this.groupSize < 0) {
          this.groupSize = 0
        }
        if (this.groupSize > this.maxGroupSize) {
          this.groupSize = this.maxGroupSize
        }
        this.groupSize = Number(Math.round(this.groupSize))
        this.validated = true
      },
      accept() {
        this.validateGroupSize()
        this.$emit('accept', this.groupSize)
        this.$emit('input', false)
      }
    },
    watch: {
      value(v) {
        if (!v) {
          this.groupSize = 0
        }
      }
    }
  }
</script>
